import { __ } from '~/locale';

export const FIRST_DROPDOWN_INDEX = 0;

export const SEARCH_BOX_INDEX = 0;

export const SEARCH_INPUT_DESCRIPTION = 'label-search-input-description';

export const SEARCH_RESULTS_DESCRIPTION = 'label-search-results-description';

export const LABEL_FILTER_HEADER = __('Labels');

export const LABEL_FILTER_PARAM = 'label_name';

export const LABEL_AGREGATION_NAME = 'labels';
